import React from 'react'

export default function Select(props) {
    const { Icon, isError = false, children } = props
    return (
        <div className={`w-full flex items-stretch bg-white rounded-xl shadow-soft border transition focus-within:ring-2 focus-within:ring-brand-400/30 ${isError ? "border-red-400" : "border-gray-200 hover:border-gray-300 focus-within:border-brand-400"}`}>
            {Icon &&
                <span className="shrink-0 inline-flex items-center pl-3.5 pr-1 text-gray-400">
                    {Icon}
                </span>
            }
            <select {...props} className="flex-1 text-gray-900 bg-transparent outline-none text-sm rounded-xl w-full ps-2 pe-3 py-2.5">
                {children}
            </select>
        </div>
    )
}
